export default __webpack_public_path__ + "static/1046-3fdc3bf26a2a57edd3eaa36f8d8b6a3c.gif";